import React from "react";

export const SectionHeader = ({ eyebrow, title, description, action }) => (
  <div className="flex flex-wrap items-end justify-between gap-6 mb-10">
    <div>
      {eyebrow && (
        <p className="text-[11px] uppercase tracking-[0.3em] text-[#7B8B6F] mb-3">{eyebrow}</p>
      )}
      <h1 className="font-serif-display text-4xl sm:text-5xl font-light text-[#2E332C] tracking-tight">
        {title}
      </h1>
      {description && (
        <p className="text-[#5C6658] mt-3 max-w-xl leading-relaxed">{description}</p>
      )}
    </div>
    {action && <div>{action}</div>}
  </div>
);

export const Stat = ({ label, value, accent = false, testId }) => (
  <div className="elegant-card p-5 sm:p-7" data-testid={testId}>
    <p className="text-[11px] uppercase tracking-[0.25em] text-[#5C6658]">{label}</p>
    <p
      className={`font-serif-display text-base sm:text-2xl lg:text-3xl mt-3 whitespace-nowrap leading-tight ${
        accent ? "text-[#C4A77D]" : "text-[#2E332C]"
      }`}
      title={String(value)}
    >
      {value}
    </p>
  </div>
);

export const Empty = ({ title, hint }) => (
  <div className="elegant-card p-12 text-center">
    <div className="w-12 h-12 mx-auto rounded-full bg-[#F1EEE3] flex items-center justify-center mb-4">
      <span className="text-[#7B8B6F] text-xl">✦</span>
    </div>
    <h3 className="font-serif-display text-2xl text-[#2E332C]">{title}</h3>
    {hint && <p className="text-sm text-[#5C6658] mt-2">{hint}</p>}
  </div>
);
